import { render, staticRenderFns } from "./PortfolioFooter.vue?vue&type=template&id=f8fff1f4&scoped=true&"
var script = {}
import style0 from "./PortfolioFooter.vue?vue&type=style&index=0&id=f8fff1f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fff1f4",
  null
  
)

export default component.exports